module.exports = __webpack_public_path__ + "img/e.f1508f9e.svg";